import { GENERIC_VALIDATION_MESSAGE } from '../../blaze-plugins/shopware-fe-kp/components/constants';

const getFormFields = formSchema =>
  Object.keys(formSchema.properties).map(fieldKey => formSchema.properties[fieldKey]);

const getInitFormState = schema =>
  Object.fromEntries(
    Object.entries(schema.properties).map(([key, field]) => [
      key,
      {
        value: field.value || (field.formFieldType === 'checkbox' ? false : ''),
        error: null,
        validationMessage: field.errorMessage || GENERIC_VALIDATION_MESSAGE,
        isRequired: !!field.isRequired
      }
    ])
  );
export { getFormFields, getInitFormState };
